const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/team.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/team')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface TeamMember {
  id: string;
  businessId: string;
  userClerkId: string | null;
  roleId: string;
  roleName: string;
  roleType: string;
  locationIds: string[];
  status: string;
  inviteEmail: string;
  invitedBy: string;
  displayName: string | null;
  title: string | null;
  phone: string | null;
  specializations: string[] | null;
  joinedAt: string | null;
  createdAt: string;
  user: {
    fullName: string;
    imageUrl: string;
    email: string;
  } | null;
}
interface Role {
  id: string;
  name: string;
  type: string;
}